/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 */
import { motion, useReducedMotion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import logoArabic from "../../../assets/logoArabic.png";
import logoEnglish from "../../../assets/logoEnglish.png";

export default function LandingHero({ isArabic }) {
  const navigate = useNavigate();
  const reduce = useReducedMotion();

  const fade = (delay = 0) =>
    reduce
      ? {}
      : {
          initial: { opacity: 0, y: 24 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] },
        };

  return (
    <section className="gl-hero" id="hero">
      <div className="gl-shell gl-hero__grid">
        <div>
          <motion.img
            {...fade(0)}
            className="gl-hero__brand"
            src={isArabic ? logoArabic : logoEnglish}
            alt={isArabic ? "مدار المجرة" : "Madar Al-Majarra"}
          />

          <motion.p {...fade(0.08)} className="gl-eyebrow">
            {isArabic ? "منصة SaaS للمتاجر الإلكترونية" : "E-commerce SaaS Platform"}
          </motion.p>

          <motion.h1 {...fade(0.12)} className="gl-hero__h1">
            {isArabic ? (
              <>
                أطلق متجرك في <span>مدار المجرة</span>
              </>
            ) : (
              <>
                Launch your store in <span>Madar Galaxy</span>
              </>
            )}
          </motion.h1>

          <motion.p {...fade(0.18)} className="gl-hero__desc">
            {isArabic
              ? "نظام متكامل لإنشاء وإدارة وبيع المتاجر الإلكترونية — بسرعة عالمية، وهوية عراقية، وتجربة فضائية المستقبل."
              : "An all-in-one system to create, manage, and sell through online stores — global speed, Iraqi identity, and a futuristic galaxy experience."}
          </motion.p>

          <motion.div {...fade(0.24)} className="gl-hero__ctas">
            <button
              type="button"
              className="gl-btn gl-btn--gold"
              onClick={() => navigate("/signup")}
            >
              {isArabic ? "ابدأ الآن" : "Start Now"}
            </button>
            <button
              type="button"
              className="gl-btn gl-btn--ghost"
              onClick={() =>
                document.getElementById("why")?.scrollIntoView({ behavior: "smooth" })
              }
            >
              {isArabic ? "مشاهدة المميزات" : "Explore Features"}
            </button>
          </motion.div>

          <motion.div {...fade(0.3)} className="gl-hero__trust">
            <span>
              <strong>1200+</strong> {isArabic ? "متجر" : "stores"}
            </span>
            <span>
              <strong>98%</strong> {isArabic ? "رضا" : "satisfaction"}
            </span>
            <span>
              <strong>24/7</strong> {isArabic ? "دعم" : "support"}
            </span>
          </motion.div>
        </div>

        <motion.div
          className="gl-hero__stage"
          initial={reduce ? false : { opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.85, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="gl-hero__glow" />
          <div className="gl-hero__mock">
            <img
              src="/showcase/dashboard.jpeg"
              alt={isArabic ? "لوحة تحكم مدار" : "Madar dashboard"}
              loading="eager"
            />
          </div>
          <div className="gl-hero__orbit-chip gl-hero__orbit-chip--1">
            <b>+32%</b> {isArabic ? "نمو المبيعات" : "sales growth"}
          </div>
          <div className="gl-hero__orbit-chip gl-hero__orbit-chip--2">
            {isArabic ? "تقارير لحظية" : "Live analytics"}
          </div>
          <div className="gl-hero__orbit-chip gl-hero__orbit-chip--3">
            {isArabic ? "متجر جاهز خلال دقائق" : "Store live in minutes"}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
